// Comprehensive global timezones list organized by region
export const TIMEZONES = [
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', group: 'UTC' },
  
  // Americas
  { value: 'America/New_York', label: 'Eastern Time (ET) - New York', group: 'Americas' },
  { value: 'America/Chicago', label: 'Central Time (CT) - Chicago', group: 'Americas' },
  { value: 'America/Denver', label: 'Mountain Time (MT) - Denver', group: 'Americas' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT) - Los Angeles', group: 'Americas' },
  { value: 'America/Anchorage', label: 'Alaska Time - Anchorage', group: 'Americas' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time - Honolulu', group: 'Americas' },
  { value: 'America/Phoenix', label: 'Arizona Time - Phoenix', group: 'Americas' },
  { value: 'America/Toronto', label: 'Eastern Time - Toronto', group: 'Americas' },
  { value: 'America/Vancouver', label: 'Pacific Time - Vancouver', group: 'Americas' },
  { value: 'America/Mexico_City', label: 'Central Time - Mexico City', group: 'Americas' },
  { value: 'America/Bogota', label: 'Colombia Time - Bogota', group: 'Americas' },
  { value: 'America/Lima', label: 'Peru Time - Lima', group: 'Americas' },
  { value: 'America/Santiago', label: 'Chile Time - Santiago', group: 'Americas' },
  { value: 'America/Buenos_Aires', label: 'Argentina Time - Buenos Aires', group: 'Americas' },
  { value: 'America/Sao_Paulo', label: 'Brasilia Time - Sao Paulo', group: 'Americas' },
  { value: 'America/Caracas', label: 'Venezuela Time - Caracas', group: 'Americas' },
  { value: 'America/Halifax', label: 'Atlantic Time - Halifax', group: 'Americas' },
  { value: 'America/St_Johns', label: 'Newfoundland Time - St. Johns', group: 'Americas' },
  
  // Europe
  { value: 'Europe/London', label: 'GMT/BST - London', group: 'Europe' },
  { value: 'Europe/Dublin', label: 'Ireland Time - Dublin', group: 'Europe' },
  { value: 'Europe/Paris', label: 'Central European Time - Paris', group: 'Europe' },
  { value: 'Europe/Berlin', label: 'Central European Time - Berlin', group: 'Europe' },
  { value: 'Europe/Amsterdam', label: 'Central European Time - Amsterdam', group: 'Europe' },
  { value: 'Europe/Brussels', label: 'Central European Time - Brussels', group: 'Europe' },
  { value: 'Europe/Zurich', label: 'Central European Time - Zurich', group: 'Europe' },
  { value: 'Europe/Vienna', label: 'Central European Time - Vienna', group: 'Europe' },
  { value: 'Europe/Rome', label: 'Central European Time - Rome', group: 'Europe' },
  { value: 'Europe/Madrid', label: 'Central European Time - Madrid', group: 'Europe' },
  { value: 'Europe/Lisbon', label: 'Western European Time - Lisbon', group: 'Europe' },
  { value: 'Europe/Stockholm', label: 'Central European Time - Stockholm', group: 'Europe' },
  { value: 'Europe/Oslo', label: 'Central European Time - Oslo', group: 'Europe' },
  { value: 'Europe/Copenhagen', label: 'Central European Time - Copenhagen', group: 'Europe' },
  { value: 'Europe/Helsinki', label: 'Eastern European Time - Helsinki', group: 'Europe' },
  { value: 'Europe/Warsaw', label: 'Central European Time - Warsaw', group: 'Europe' },
  { value: 'Europe/Prague', label: 'Central European Time - Prague', group: 'Europe' },
  { value: 'Europe/Budapest', label: 'Central European Time - Budapest', group: 'Europe' },
  { value: 'Europe/Athens', label: 'Eastern European Time - Athens', group: 'Europe' },
  { value: 'Europe/Bucharest', label: 'Eastern European Time - Bucharest', group: 'Europe' },
  { value: 'Europe/Kiev', label: 'Eastern European Time - Kyiv', group: 'Europe' },
  { value: 'Europe/Moscow', label: 'Moscow Time - Moscow', group: 'Europe' },
  { value: 'Europe/Istanbul', label: 'Turkey Time - Istanbul', group: 'Europe' },
  
  // Asia
  { value: 'Asia/Dubai', label: 'Gulf Standard Time - Dubai', group: 'Asia' },
  { value: 'Asia/Riyadh', label: 'Arabian Time - Riyadh', group: 'Asia' },
  { value: 'Asia/Tehran', label: 'Iran Time - Tehran', group: 'Asia' },
  { value: 'Asia/Karachi', label: 'Pakistan Time - Karachi', group: 'Asia' },
  { value: 'Asia/Kolkata', label: 'India Standard Time - Mumbai/Delhi', group: 'Asia' },
  { value: 'Asia/Dhaka', label: 'Bangladesh Time - Dhaka', group: 'Asia' },
  { value: 'Asia/Bangkok', label: 'Indochina Time - Bangkok', group: 'Asia' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Indochina Time - Ho Chi Minh', group: 'Asia' },
  { value: 'Asia/Jakarta', label: 'Western Indonesia Time - Jakarta', group: 'Asia' },
  { value: 'Asia/Singapore', label: 'Singapore Time - Singapore', group: 'Asia' },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia Time - Kuala Lumpur', group: 'Asia' },
  { value: 'Asia/Manila', label: 'Philippine Time - Manila', group: 'Asia' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong Time - Hong Kong', group: 'Asia' },
  { value: 'Asia/Shanghai', label: 'China Standard Time - Shanghai', group: 'Asia' },
  { value: 'Asia/Taipei', label: 'Taiwan Time - Taipei', group: 'Asia' },
  { value: 'Asia/Seoul', label: 'Korea Standard Time - Seoul', group: 'Asia' },
  { value: 'Asia/Tokyo', label: 'Japan Standard Time - Tokyo', group: 'Asia' },
  
  // Australia & Pacific
  { value: 'Australia/Perth', label: 'Australian Western Time - Perth', group: 'Australia & Pacific' },
  { value: 'Australia/Adelaide', label: 'Australian Central Time - Adelaide', group: 'Australia & Pacific' },
  { value: 'Australia/Darwin', label: 'Australian Central Time - Darwin', group: 'Australia & Pacific' },
  { value: 'Australia/Brisbane', label: 'Australian Eastern Time - Brisbane', group: 'Australia & Pacific' },
  { value: 'Australia/Sydney', label: 'Australian Eastern Time - Sydney', group: 'Australia & Pacific' },
  { value: 'Australia/Melbourne', label: 'Australian Eastern Time - Melbourne', group: 'Australia & Pacific' },
  { value: 'Australia/Hobart', label: 'Australian Eastern Time - Hobart', group: 'Australia & Pacific' },
  { value: 'Pacific/Auckland', label: 'New Zealand Time - Auckland', group: 'Australia & Pacific' },
  { value: 'Pacific/Fiji', label: 'Fiji Time - Suva', group: 'Australia & Pacific' },
  { value: 'Pacific/Guam', label: 'Chamorro Time - Guam', group: 'Australia & Pacific' },
  
  // Africa
  { value: 'Africa/Cairo', label: 'Egypt Time - Cairo', group: 'Africa' },
  { value: 'Africa/Johannesburg', label: 'South Africa Time - Johannesburg', group: 'Africa' },
  { value: 'Africa/Lagos', label: 'West Africa Time - Lagos', group: 'Africa' },
  { value: 'Africa/Nairobi', label: 'East Africa Time - Nairobi', group: 'Africa' },
  { value: 'Africa/Casablanca', label: 'Morocco Time - Casablanca', group: 'Africa' },
  { value: 'Africa/Algiers', label: 'Central European Time - Algiers', group: 'Africa' },
  { value: 'Africa/Accra', label: 'Ghana Mean Time - Accra', group: 'Africa' },
  
  // Middle East
  { value: 'Asia/Jerusalem', label: 'Israel Time - Jerusalem', group: 'Middle East' },
  { value: 'Asia/Beirut', label: 'Lebanon Time - Beirut', group: 'Middle East' },
  { value: 'Asia/Baghdad', label: 'Arabian Time - Baghdad', group: 'Middle East' },
  { value: 'Asia/Kuwait', label: 'Arabian Time - Kuwait', group: 'Middle East' },
  { value: 'Asia/Qatar', label: 'Arabian Time - Doha', group: 'Middle East' },
  
  // Atlantic
  { value: 'Atlantic/Azores', label: 'Azores Time - Azores', group: 'Atlantic' },
  { value: 'Atlantic/Reykjavik', label: 'Iceland Time - Reykjavik', group: 'Atlantic' },
  { value: 'Atlantic/Bermuda', label: 'Atlantic Time - Bermuda', group: 'Atlantic' }
];

// Group timezones for optgroup display
export const TIMEZONE_GROUPS = ['UTC', 'Americas', 'Europe', 'Asia', 'Australia & Pacific', 'Africa', 'Middle East', 'Atlantic'];
